/** How often the open comments panel polls for new comments (ms). */
export const COMMENTS_REFETCH_INTERVAL_MS = 20_000;

/** Comment body length cap — must match the backend schema. */
export const COMMENT_MAX_LENGTH = 5000;

/**
 * Base React Query key prefix for a note's comment tree.
 *
 * The fetch hook appends the viewer identity (`userData.id` or the share token)
 * to this prefix so the singleton cache can't leak one viewer's comments to a
 * different viewer on the same tab. Use this prefix for invalidation — React
 * Query prefix-matches it against the longer, viewer-scoped fetch key.
 */
export const commentsQueryKey = (noteId?: string) => ['note-comments', noteId] as const;
